var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('UAMTable')],1)],1),(_vm.$store.state.user && _vm.$store.getters.getAccessByLevels(['uam']))?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('RootTable')],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }